export default {
  labels: {
    open: 'Vis varer',
    collapse: 'Skjul varer',
    in_stock: 'På lager',
    out_of_stock: 'Udsolgt',
    visible: 'Synlig i menu',
    hidden: 'Skjult i menu',
  },
  list: {
    name: 'Menupunkt',
    price: 'Pris',
    is_available: 'PÅ LAGER/UDSOLGT',
  },
};
